import React from "react";
import Loader from "react-loader-spinner";
import "react-loader-spinner/dist/loader/css/react-spinner-loader.css";

interface CustomLoaderProps {
  left?: string;
  top?: string;
  position?: string;
}

function CustomLoader({ left, top, position }: CustomLoaderProps) {
  const Left = left ? left : "50%";
  const Top = top ? top : "50%";
  const Position = position ? position : "fixed";

  return (
    <div
      style={{
        position: Position as string,
        top: Top,
        left: Left,
        transform: `translate(-${Top}, -${Left})`, // Fixed the transform values
      }}
    >
      <Loader
        type="Puff"
        color="#00BFFF"
        height={100}
        width={100}
        timeout={10000}
      />
    </div>
  );
}

export default CustomLoader;
